import React from "react";

/**
 * Jeu d'icônes en SVG inline (aucune dépendance externe).
 * Toutes les icônes héritent de la couleur du texte via `currentColor`.
 */

const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const Svg = ({ size = 24, children, ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    aria-hidden="true"
    focusable="false"
    {...base}
    {...rest}
  >
    {children}
  </svg>
);

/* --- Services --- */

export const Rings = (p) => (
  <Svg {...p}>
    <circle cx="9.5" cy="14.5" r="5.5" />
    <circle cx="15.5" cy="14.5" r="5.5" />
    <path d="M12 5.5 10.6 3h2.8L12 5.5z" />
    <path d="M12 2.2v.6" />
  </Svg>
);

export const Family = (p) => (
  <Svg {...p}>
    <circle cx="8" cy="7" r="2.6" />
    <circle cx="16.5" cy="8" r="2.2" />
    <path d="M3.5 19v-2.2A4.3 4.3 0 0 1 7.8 12.5h.6a4.3 4.3 0 0 1 4.3 4.3V19" />
    <path d="M15 12.6h1.3a4 4 0 0 1 4 4V19" />
  </Svg>
);

export const Briefcase = (p) => (
  <Svg {...p}>
    <rect x="2.8" y="7.2" width="18.4" height="12" rx="2.2" />
    <path d="M8.6 7.2V5.6a1.8 1.8 0 0 1 1.8-1.8h3.2a1.8 1.8 0 0 1 1.8 1.8v1.6" />
    <path d="M2.8 12.4h18.4" />
    <path d="M10.4 12.4h3.2" />
  </Svg>
);

export const Plane = (p) => (
  <Svg {...p}>
    <path d="M20.5 3.5a1.9 1.9 0 0 1 0 2.7l-2.6 2.6 1.5 8.2-1.9 1.9-3.4-6.3-3.2 3.2.3 2.9-1.4 1.4-1.7-3.2-3.2-1.7 1.4-1.4 2.9.3 3.2-3.2-6.3-3.4 1.9-1.9 8.2 1.5 2.6-2.6a1.9 1.9 0 0 1 2.7 0z" />
  </Svg>
);

export const Route = (p) => (
  <Svg {...p}>
    <path d="M7 2.8a3.6 3.6 0 0 1 3.6 3.6c0 2.6-3.6 6.2-3.6 6.2S3.4 9 3.4 6.4A3.6 3.6 0 0 1 7 2.8z" />
    <circle cx="7" cy="6.4" r="1.2" />
    <path d="M17 10.8a3.4 3.4 0 0 1 3.4 3.4c0 2.5-3.4 5.9-3.4 5.9s-3.4-3.4-3.4-5.9a3.4 3.4 0 0 1 3.4-3.4z" />
    <circle cx="17" cy="14.2" r="1.1" />
  </Svg>
);

export const Backpack = (p) => (
  <Svg {...p}>
    <path d="M5.2 9.4A4.6 4.6 0 0 1 9.8 4.8h4.4a4.6 4.6 0 0 1 4.6 4.6v8.2a2 2 0 0 1-2 2H7.2a2 2 0 0 1-2-2V9.4z" />
    <path d="M9.2 4.8V4a2.8 2.8 0 0 1 5.6 0v.8" />
    <path d="M8.8 12.4h6.4v3.2H8.8z" />
    <path d="M11.4 14h1.2" />
  </Svg>
);

export const Wheelchair = (p) => (
  <Svg {...p}>
    <circle cx="10.2" cy="4.4" r="1.9" />
    <path d="M9 8v5.4h4.6l3 5.4" />
    <path d="M9 11.2h4" />
    <circle cx="10.6" cy="16.4" r="4.6" />
    <path d="M18.6 18.8h2.2" />
  </Svg>
);

export const Calendar = (p) => (
  <Svg {...p}>
    <rect x="3.2" y="5" width="17.6" height="15.4" rx="2.2" />
    <path d="M3.2 9.6h17.6" />
    <path d="M8 3.4v3.4M16 3.4v3.4" />
    <path d="M7.4 13h1.4M11.3 13h1.4M15.2 13h1.4M7.4 16.6h1.4M11.3 16.6h1.4M15.2 16.6h1.4" />
  </Svg>
);

/* --- Atouts / valeurs --- */

export const Driver = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="3.4" />
    <path d="M5.4 20v-1a5.2 5.2 0 0 1 5.2-5.2h2.8a5.2 5.2 0 0 1 5.2 5.2v1" />
    <path d="M9.2 5.6c1.6-2 4.4-1.8 5.6.4" />
  </Svg>
);

export const Passengers = (p) => (
  <Svg {...p}>
    <circle cx="7" cy="8.4" r="2.4" />
    <circle cx="12" cy="7" r="2.4" />
    <circle cx="17" cy="8.4" r="2.4" />
    <path d="M2.8 17.6a4.2 4.2 0 0 1 4.2-4.2M12 12.2a4.6 4.6 0 0 1 4.6 4.6M12 12.2a4.6 4.6 0 0 0-4.6 4.6M21.2 17.6a4.2 4.2 0 0 0-4.2-4.2" />
  </Svg>
);

export const Pin = (p) => (
  <Svg {...p}>
    <path d="M12 2.8a6.2 6.2 0 0 1 6.2 6.2c0 4.6-6.2 12.2-6.2 12.2S5.8 13.6 5.8 9A6.2 6.2 0 0 1 12 2.8z" />
    <circle cx="12" cy="9" r="2.3" />
  </Svg>
);

export const Check = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="m8 12.3 2.7 2.7L16 9.6" />
  </Svg>
);

export const Comfort = (p) => (
  <Svg {...p}>
    <path d="M5 11.4V7.6A2.6 2.6 0 0 1 7.6 5h8.8A2.6 2.6 0 0 1 19 7.6v3.8" />
    <path d="M3.4 11.4h17.2v4.4a2 2 0 0 1-2 2H5.4a2 2 0 0 1-2-2v-4.4z" />
    <path d="M6.6 17.8V19.6M17.4 17.8V19.6" />
  </Svg>
);

export const Shield = (p) => (
  <Svg {...p}>
    <path d="M12 2.9 19.3 5.6v5.9c0 4.3-3 8.1-7.3 9.6-4.3-1.5-7.3-5.3-7.3-9.6V5.6L12 2.9z" />
    <path d="m9 11.9 2.2 2.2 4-4.2" />
  </Svg>
);

export const Clock = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 6.8V12l3.4 2" />
  </Svg>
);

export const Discretion = (p) => (
  <Svg {...p}>
    <path d="M2.6 12S6.4 5.8 12 5.8 21.4 12 21.4 12 17.6 18.2 12 18.2 2.6 12 2.6 12z" />
    <circle cx="12" cy="12" r="2.8" />
    <path d="m4 20 16-16" />
  </Svg>
);

export const Service = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3" />
    <path d="M3.6 19.2v-.8A4.8 4.8 0 0 1 8.4 13.6h1.2a4.8 4.8 0 0 1 4.8 4.8v.8" />
    <path d="M16.6 8.4h4.2M18.7 6.3v4.2" />
  </Svg>
);

/* --- Interface --- */

export const Phone = (p) => (
  <Svg {...p}>
    <path d="M6.4 3.6h3l1.5 3.8-2 1.4a11.4 11.4 0 0 0 5.3 5.3l1.4-2 3.8 1.5v3a1.8 1.8 0 0 1-2 1.8A15.6 15.6 0 0 1 4.6 5.6a1.8 1.8 0 0 1 1.8-2z" />
  </Svg>
);

export const Mail = (p) => (
  <Svg {...p}>
    <rect x="2.8" y="5.2" width="18.4" height="13.6" rx="2.2" />
    <path d="m3.4 7 8.6 5.8L20.6 7" />
  </Svg>
);

export const CalendarSmall = (p) => (
  <Svg {...p}>
    <rect x="3.4" y="5.4" width="17.2" height="15" rx="2" />
    <path d="M3.4 9.8h17.2M8 3.6v3.4M16 3.6v3.4" />
  </Svg>
);

export const ChevronLeft = (p) => (
  <Svg {...p}>
    <path d="m14.5 5.5-6.2 6.5 6.2 6.5" />
  </Svg>
);

export const ChevronRight = (p) => (
  <Svg {...p}>
    <path d="m9.5 5.5 6.2 6.5-6.2 6.5" />
  </Svg>
);

export const CheckCircle = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.6" />
    <path d="m8.3 12.2 2.5 2.5 4.9-5.1" />
  </Svg>
);

export const Facebook = (p) => (
  <Svg {...p}>
    <path d="M14.2 8.2h2V5.6h-2c-1.9 0-3.4 1.5-3.4 3.4v1.6H8.6v2.6h2.2v6.2h2.6v-6.2h2.2l.4-2.6h-2.6V9c0-.4.4-.8.8-.8z" />
  </Svg>
);

export const Instagram = (p) => (
  <Svg {...p}>
    <rect x="4" y="4" width="16" height="16" rx="4.4" />
    <circle cx="12" cy="12" r="3.6" />
    <circle cx="16.6" cy="7.4" r="0.8" fill="currentColor" />
  </Svg>
);

export const Telegram = (p) => (
  <Svg {...p}>
    <path d="M21 4 3 11.2l5.4 1.9M21 4 15 20l-6.6-6.9M21 4 8.4 13.1v5.4" />
  </Svg>
);

export const Whatsapp = (p) => (
  <Svg {...p}>
    <path d="M20 11.7a8 8 0 0 1-11.9 7L3.9 20l1.3-4.1A8 8 0 1 1 20 11.7z" />
    <path d="M9 8.6c.6-.2 1 .2 1.2.7l.4 1c.1.3 0 .6-.2.8l-.4.4a5 5 0 0 0 2.5 2.5l.4-.4c.2-.2.5-.3.8-.2l1 .4c.5.2.9.6.7 1.2" />
  </Svg>
);

/* Table de correspondance : nom (data.json) -> composant */
const registry = {
  rings: Rings,
  family: Family,
  briefcase: Briefcase,
  plane: Plane,
  route: Route,
  backpack: Backpack,
  calendar: Calendar,
  wheelchair: Wheelchair,
  driver: Driver,
  passengers: Passengers,
  pin: Pin,
  check: Check,
  comfort: Comfort,
  shield: Shield,
  clock: Clock,
  discretion: Discretion,
  service: Service,
  phone: Phone,
  mail: Mail,
};

export const Icon = ({ name, ...rest }) => {
  const Cmp = registry[name];
  return Cmp ? <Cmp {...rest} /> : null;
};

export const Stars = ({ rating = 5 }) => (
  <span className="stars" aria-label={`${rating} sur 5`}>
    {[0, 1, 2, 3, 4].map((i) => {
      const filled = rating - i;
      const pct = filled >= 1 ? 100 : filled > 0 ? Math.round(filled * 100) : 0;
      return (
        <svg key={i} viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">
          <defs>
            <linearGradient id={`star-${i}-${pct}`}>
              <stop offset={`${pct}%`} stopColor="#f0a03c" />
              <stop offset={`${pct}%`} stopColor="#e3dbe6" />
            </linearGradient>
          </defs>
          <path
            fill={`url(#star-${i}-${pct})`}
            d="m12 2.6 2.9 5.9 6.5.9-4.7 4.6 1.1 6.4-5.8-3-5.8 3 1.1-6.4L2.6 9.4l6.5-.9L12 2.6z"
          />
        </svg>
      );
    })}
  </span>
);
